import React, { useState, useEffect } from 'react';

import { 
  PactBoonFeature,
} from "@dndModels";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props { 
  obj: PactBoonFeature;
  onChange: (changed: PactBoonFeature) => void;
  disabled?: boolean;
}

export default function PactBoonFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  return (
    <SelectObjectBox 
      name="Pact Boons"
      data_type="pact_boon"
      values={myObj.pb_ids} 
      disabled={disabled}
      multiple
      onChange={(changed: string[]) => {
        const floating_feature = myObj;
        floating_feature.pb_ids = changed;
        setMyObj(floating_feature);
        onChange(floating_feature);
      }}
    />
  );
}
